// @ts-nocheck
/// <reference path="../../../../../rcwebmodels/gensetstatus.cs.d.ts" />
import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import GensetStatus from '../routecomponents/GensetStatus';
import { GensetStatusGrid } from '../childcomponents/GensetStatusGrid';
import Formatters from '../../actions/Formatters';
import { GensetCellRender } from '../../actions/GensetCellRender';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { GridToolBarGensetPopups } from '../sharedcomponents/GridToolBarGensetPopups';
import GensetFormatters from '../../actions/GensetFormatter';
// pull in the ag-grid styles we're interested in
import '../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';
import 'react-datepicker/dist/react-datepicker.css';
import deletepng from '../../images/delete.png';
var Config: any = require('../../Config.json');

export interface GensetCommandsGridState {
    rowData: server.GensetStatusUI[];
    columnDefs: any[];
    Filters: GensetForwardCommandParams;   
    overlayLoadingTemplate: any;
    pageSize: any;
    gridApiParams: any;    
    GridToolBarHtml: any;
}

var colDefs;
var self;


export class GensetCommandsGrid extends React.Component<any, GensetCommandsGridState> {
    constructor(props: any) {
        super(props);
        var filterSet = new GensetForwardCommandParams();
        var overlayTemplate = '<span class="ag-overlay-loading-center">Loading...</span>';
        this.state = {
            rowData: [], columnDefs: [], Filters: filterSet, 
            overlayLoadingTemplate: overlayTemplate, pageSize: 25, gridApiParams: [],
            GridToolBarHtml: ''
        };

        self = this;
    }

    static submitCommands(commandName, paramValue, refreshGrid) {
        if (self.state.rowData.length > 0) {
            $('#globalLoader').show();
            self.state.Filters.CommandName = commandName;
            self.state.Filters.SelectedGensets = self.state.rowData;
            self.state.Filters.TempValue = paramValue;
            var forwardCommandParams = JSON.stringify(self.state.Filters);

            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/GensetPostForwardCommands', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<ValidationSeverityResult>)
                .then(data => {
                    if (data != null && data != undefined) {
                        if (data.Result != null && data.Result != undefined && data.Result.length > 0) {
                            PopupWindow.showErrorMessage("Error", data.Result);
                            $(".mm-popup__box__body").css("white-space", "pre-line");
                            $('#globalLoader').hide();
                            return;
                        }
                    }

                    if ($('#confirmPopUpModel') != undefined) {
                        $("#confirmPopUpModel .btn-close").click();
                    }
                        
                    $("#contextMenuModel .btn-close").click();  

                    if (refreshGrid == "home")
                        GensetStatusGrid.refreshDashboardGrid();
                    else
                        GensetStatus.refreshGensetStatusGrid();
                });
        }
        else
            PopupWindow.showErrorMessage("Alert", "No assets selected");
    }
    

    componentWillReceiveProps(nextprops: any) { 
        colDefs = this.createColumnDefs();  
        var gensetData = nextprops.selectedGensets;
        if (gensetData != undefined && gensetData != null) {
            this.setState({ rowData: gensetData }, () => this.renderGridToolBar());
        }        
    }

    renderGridToolBar() {
        this.setState({ GridToolBarHtml: this.renderGridToolBarHtml() });
    }

    renderGridToolBarHtml() {
        return <GridToolBarGensetPopups refreshGrid={this.refreshGrid.bind(this)} gridData={this.state.rowData} colDefs={colDefs} parentchild={"P"} formName={"GensetCommands"} />;
    }

    componentDidMount() {
        colDefs = this.createColumnDefs(); 
       
       
        
        
    }

    onGridReady(params: any) {
        params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        self.setState({ gridApiParams: params.api });
    }
    //removeIndicator(params: any) {
    //    var element = document.createElement("span");
    //    element.className = "reefer-delete";

    //    var imageElement = document.createElement("img");
    //    imageElement.src = deletepng;
    //    imageElement.title = "Remove";

    //    imageElement.onclick = function DeleteCommands() {
    //        params.api.gridOptionsWrapper.gridOptions.rowData.splice(params.rowIndex, 1);
    //        params.api.setRowData(params.api.gridOptionsWrapper.gridOptions.rowData);
    //    }

    //    element.appendChild(imageElement);

    //    return element;
    //}
    
    refreshGrid = () => {
        
        var selectedGensets = "";
        if (this.state.rowData.length > 0) {
            $('#globalLoader').show();
            $.each(this.state.rowData, function (selectedIndex, selectedValue) {
                if (selectedValue.AssetNumber != null) {
                    selectedGensets = selectedGensets == "" ? selectedValue.AssetNumber : selectedGensets + "," + selectedValue.AssetNumber;
                }
            });
            var gensetSearchFilters: server.ReeferSearchFilters = {
                SelectedOem: '', SelectedCountry: '', SelectedReefer: selectedGensets, SelectedGeofence: '', SelectedInterval: '', SelectedGeofenceInside: '', SelectedVesselCode: '', StatusFilters: [], AllReefers: '', CustomAttributeFilters: null, SelectedAssetTypes: '',
                SelectedAssetStates: '', SelectedBookingNumber: '', SelectedVesselCD: '', SelectedVoyage: '', SelectedCall: '', SelectedCargoCareProfiles: '', SelectedPod: '', SelectedPol: '', SelectedCTProfileIds: [] //WI-26881
                }; 
        
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/GensetStatusDataSP', { method: 'POST', body: JSON.stringify(gensetSearchFilters), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.GensetStatusUI[]>)
                .then(data => {
                    this.setState({
                        rowData: data
                    }, () => {
                        this.renderGridToolBar();                            
                        $('#globalLoader').hide();   
                    });
                });
        }

        self.state.gridApiParams.paginationGoToFirstPage();
        
    };    

    createColumnDefs() {
        return [
            { headerName: "Remove", field: "AssetNumber", width: 85, cellRenderer: GensetCellRender.removeIndicator  },  
            { headerName: "State", field: "IsPending", width: 85, cellRenderer: GensetCellRender.stringTypeFormatter },            
            //{ headerName: "CC", field: "CCSeverityLevelGenset", width: 65, cellRenderer: Formatters.stringTypeFormatter },            
            { headerName: "SW", field: "IgnitionOn", width: 65, cellRenderer: GensetCellRender.gensetSwitchFormatterImg },
            { headerName: "ENG", field: "GensetRunning", width: 65, cellRenderer: GensetCellRender.gensetRunningFormatter },
            { headerName: "VSL", field: "VesselCd", width: 80, cellRenderer: GensetCellRender.stringTypeFormatter },
            { headerName: "OEM", field: "OEMTypeCD", cellRenderer: GensetFormatters.oemTypeFormatterGensetForFilter, width: 130 },
            { headerName: "Genset ID", field: "AssetNumber", cellRenderer: GensetCellRender.stringTypeFormatter, width: 150 },            
            { headerName: "Event", field: "EventDescription", cellRenderer: GensetCellRender.stringTypeFormatter, width: 180 },
            { headerName: "Event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 180 },           
        ];
    }    

    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;

        self.setState({
            pageSize: pageSize
        });

        self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
        self.state.gridApiParams.paginationGoToFirstPage();
        //alert(this.state.pageSize);
    }

    public render() {
        return <div>
            <div>
                {this.state.GridToolBarHtml}                
            </div>
            <div className="ag-theme-fresh containerstyle_commands">
                <AgGridReact
                    columnDefs={colDefs}
                    rowData={this.state.rowData}
                    onGridReady={this.onGridReady}
                    pagination={true}
                    accentedSort={true}
                    paginationPageSize={this.state.pageSize}
                    overlayLoadingTemplate={this.state.overlayLoadingTemplate}>
                </AgGridReact>
            </div>
            <div className='pageSize'>
                <span className='pageSize-lable'>Page Size:</span>
                <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                </select>
            </div>
        </div>
    }
}

class GensetForwardCommandParams {
    SelectedGensets: server.GensetStatusUI[];
    CommandName: string;
	TempValue: string;   
}
class ValidationSeverityResult {
    Serverity: string;
    Result: string;
}